import { gql } from 'react-apollo';

export * from 'legacy/packages/wizards/src/queries';

// Returns stuff about Me
export const me = gql`
  query me {
    me {
      id
      email
      initId
      username
      firstName
      lastName
      userRole
      isStudent
      ssoLogin
      aiCode
      pilot
      generateData
      registeredDate
      importId
      preferences {
        preference
        value
        context
        contextId
      }
      sections {
        id
        masterSubjectId
        name
        educationPeriod
        parentId
        importId
        teacherId
        teacherCbPersonId
        sectionType
      }
      schoolSet {
        initId
        groupImportId
        name
        parentId
        timezone
      }
      districts {
        groupImportId
      }
      programs
      lastLogin
    }
    teacherSubjects {
      id
      name
      subjectProgram
      classes {
        id
        name
        parentId
        educationPeriod
        students {
          id: initId
          firstName
          lastName
          apuid
          email
        }
        studentsPrior {
          id: initId
          firstName
          lastName
          apuid
          email
        }
      }
      educationPeriods {
        id
        displayValue
        contentAvailableAt
        endDate
      }
      subjects {
        initId
        name
      }
    }
    studentSubjects {
      id
      name
      subjectProgram
      initId
    }
    adminSubjects {
      id
      initId
      importId
      masterSubjectId
      name
      parentId
      subjectProgram
      type
      url
      containsSecureQuestions
    }
    educationPeriods {
      id
      displayValue
      contentAvailableAt
      endDate
    }
    currentEducationPeriod {
      id
      displayValue
      endDate
    }
    nextEducationPeriod {
      id
      displayValue
    }
  }
`;

// Returns user's available education periods
export const getUserEducationPeriods = gql`
  query getUserEducationPeriods($subjectId: Int!) {
    userEducationPeriods(subjectId: $subjectId) {
      id
      displayValue
    }
  }
`;

export const getAdminInfo = gql`
  query getAdminInfo($id: String!, $educationPeriod: String) {
    adminSubject(id: $id) {
      units
      nav {
        navName
        navUrl
      }
      classes {
        id
        name
      }
      subjectAllClasses(educationPeriod: $educationPeriod) {
        id
        name
        students {
          id: initId
          firstName
          lastName
        }
        studentsPrior {
          id: initId
          firstName
          lastName
        }
      }
    }
  }
`;

export const getTeacherInfo = gql`
  query getTeacherInfo($id: String!, $educationPeriod: String!) {
    teacherSubject(id: $id, educationPeriod: $educationPeriod) {
      subjects(educationPeriod: $educationPeriod) {
        id
        initId
        importId
        name
        parentId
        type
        masterSubjectId
        containsSecureQuestions
      }
      units
      nav {
        navName
        navUrl
      }
      classes {
        id
        name
        importId
        subjectProgram
        parentId
        educationPeriod
        timezone
        latestAssignment {
          id
          title
          score
        }
        recent {
          id
          title
          classId
          status {
            submitted
            inProgress
            entered
            available
          }
        }
        exam {
          deadline
          yes
          no
          defer
        }
        resourcesAssigned {
          assignedAt
          resource
          type
          subjectId
        }
      }
      contentExpired
    }
    teacherSubjects {
      id
      name
      subjectProgram
      educationPeriods {
        id
        displayValue
        contentAvailableAt
        endDate
      }
      labels {
        labelId
        name
        order
        userId
        parentId
        studentVisible
      }
    }
  }
`;

export const getStudentInfo = gql`
  query getStudentInfo($id: String!) {
    studentSubject(id: $id) {
      labels {
        labelId
        name
        order
        userId
        parentId
      }
    }
  }
`;

export const getAdminPlCourses = gql`
  query getAdminPlCourses {
    adminPlCourses {
      id
      name
      importId
      initId
      type
    }
  }
`;

export const getAssessmentGroupByAssignmentInfo = gql`
  query getAssessmentGroupByAssignmentInfo($assignmentId: Int!) {
    assessmentGroupByAssignmentInfo(assignmentId: $assignmentId) {
      id
      name
      subject
      type
      semester
      members {
        partName
        partType
        sortOrder
        assessmentId
        unitMask
      }
      window {
        registrationStartDate
        registrationEndDate
        winterWindowStartDate
        winterWindowEndDate
        springWindowStartDate
        springWindowEndDate
      }
    }
  }
`;

export const getAssignmentRestrictions = gql`
  query getAssignmentRestrictions($assignmentId: Int!) {
    assignmentRestrictionStatus(assignmentId: $assignmentId) {
      isRestricted
    }
  }
`;

export const getPerformanceTiers = gql`
  query getPerformanceTiers($subjectId: Int!) {
    performanceTiers(subjectId: $subjectId) {
      type
      label
      bottomLimit
      topLimit
      color
    }
  }
`;

export const saveFeedback = gql`
  mutation saveFeedback(
    $assignmentId: Int!
    $studentId: Int!
    $content: JSONString
  ) {
    studentFeedback(
      assignmentId: $assignmentId
      studentId: $studentId
      content: $content
    ) {
      ok
    }
  }
`;

export const savePreference = gql`
  mutation savePreference(
    $userId: String!
    $preference: PreferenceName!
    $value: JSONString!
    $context: Context
    $contextId: String
  ) {
    savePreference(
      userId: $userId
      preference: $preference
      value: $value
      context: $context
      contextId: $contextId
    ) {
      ok
    }
  }
`;

export const saveSessions = gql`
  mutation saveSessions(
    $assignmentId: String!
    $template: String!
    $scoringSessionTemplate: String
    $sessions: [Session]!
  ) {
    saveSessions(
      assignmentId: $assignmentId
      template: $template
      scoringSessionTemplate: $scoringSessionTemplate
      sessions: $sessions
    ) {
      ok
    }
  }
`;

export const assessmentPreviewData = gql`
  query assessmentPreview(
    $assessmentId: String!
    $config: String
    $showCorrectAnswers: Boolean
    $educationPeriod: String
    $subjectId: Int
  ) {
    assessmentPreview(
      assessmentId: $assessmentId
      config: $config
      showCorrectAnswers: $showCorrectAnswers
      educationPeriod: $educationPeriod
      masterSubjectId: $subjectId
    ) {
      learnositySignedRequest
      allowCalculatorForItems {
        itemId
        revisionId
        learnosityItemReference
      }
      sppVideos {
        questionPartReference
        displayName
        resourceId
        videoId
        unitId
        providerVideoId
      }
    }
    assessment(assessmentId: $assessmentId, educationPeriod: $educationPeriod) {
      id: itemId
      title
      learnosityItemReference
      questions(educationPeriod: $educationPeriod) {
        ... on MultipleChoiceQuestion {
          isSecure
          isRetired
          itemId
          title
          learnosityItemReference
          isCbPracticeQuiz
          isTopicQuestion
          type: __typename
          used_detail: usedDetail(educationPeriod: $educationPeriod)
          owner_id: ownerId
          itemShareChain
          isTeacherAuthored
        }
        ... on FreeResponseQuestion {
          isSecure
          isRetired
          itemId
          title
          learnosityItemReference
          isCbPracticeQuiz
          isTopicQuestion
          type: __typename
          children: scoringRubric {
            id
            title
            learnosityItemReference
            type: __typename
          }
          used_detail: usedDetail(educationPeriod: $educationPeriod)
          owner_id: ownerId
          itemShareChain
          isTeacherAuthored: isTeacherAuthored
        }
      }
    }
  }
`;

export const assignmentPreviewDataOnly = gql`
  query assignmentPreview(
    $assignmentId: String!
    $config: String
    $inline: Boolean
    $showCorrectAnswers: Boolean
  ) {
    assignment(assignmentId: $assignmentId) {
      id
      studentResponses
    }
    assignmentPreview(
      assignmentId: $assignmentId
      config: $config
      inline: $inline
      showCorrectAnswers: $showCorrectAnswers
    ) {
      learnositySignedRequest
      scoringRubric {
        learnositySignedRequest
        rubricCategoryReferencesByQuestion
      }
    }
  }
`;

export const assignmentReviewScoringRubric = gql`
  query assignmentReview(
    $assignmentId: String!
    $studentId: String!
    $config: String
    $inline: Boolean
    $showCorrectAnswers: Boolean
    $subjectId: Int
    $htmlId: String
    $assignmentIdAsInt: Int
    $scorerType: String
  ) {
    assignment(assignmentId: $assignmentId) {
      id
      studentScoring
      responseAnalysis(studentId: $studentId)
      scoringRubricResponses(studentId: $studentId, scorerType: $scorerType)
      scoringRubricResponseAnalysis(
        studentId: $studentId
        scorerType: $scorerType
      )
      progress(userId: $studentId) {
        submitted
        scoring
        scored
        studentScored
        teacherAndStudentScored
      }
    }
    assignmentReview(
      assignmentId: $assignmentId
      studentId: $studentId
      config: $config
      inline: $inline
      showCorrectAnswers: $showCorrectAnswers
      scorerType: "teacher"
    ) {
      scoringRubric {
        learnositySignedRequest
      }
    }
    assignmentScoringByRubric(
      studentId: $studentId
      assignmentId: $assignmentId
    ) {
      studentSessionReviewSignedRequest
      rubricCategoryReferencesByQuestion
    }
    assessmentGroupByAssignmentInfo(
      assignmentId: $assignmentIdAsInt
      subjectId: $subjectId
      htmlId: $htmlId
    ) {
      id
      name
      type
      subject
    }
  }
`;

export const assignmentProgress = gql`
  query assignmentProgress($assignmentId: String!, $studentId: String) {
    assignment(assignmentId: $assignmentId) {
      id
      progress(userId: $studentId) {
        complete
        notStarted
        started
        submitted
        scoring
        scored
        studentScored
        readyToScore
        teacherAndStudentScored
      }
    }
  }
`;

export const assignmentPreviewData = gql`
  query assignmentPreview(
    $assignmentId: String!
    $config: String
    $showCorrectAnswers: Boolean
  ) {
    assignmentPreview(
      assignmentId: $assignmentId
      config: $config
      showCorrectAnswers: $showCorrectAnswers
    ) {
      learnositySignedRequest
      allowCalculatorForItems {
        itemId
        revisionId
        learnosityItemReference
      }
    }
  }
`;

export const assignmentQuestionData = gql`
  query assignmentQuestionData($assignmentId: String!) {
    assignment(assignmentId: $assignmentId) {
      id
      title
      questions {
        ... on MultipleChoiceQuestion {
          id: itemId
          itemId
          title
          isSecure
          isRetired
          learnosityItemReference
          isCbPracticeQuiz
          isTeacherAuthored
          type: __typename
        }
        ... on FreeResponseQuestion {
          id: itemId
          itemId
          title
          isSecure
          isRetired
          learnosityItemReference
          isCbPracticeQuiz
          isTeacherAuthored
          type: __typename
          children: scoringRubric {
            id
            title
            learnosityItemReference
            type: __typename
          }
        }
      }
    }
  }
`;

export const assignmentPlayerData = gql`
  query assignmentPlayer(
    $assignmentId: String!
    $subjectId: String!
    $config: String
    $ldbChallenge: String
    $isImpersonating: Boolean!
    $impersonatingDetails: String!
  ) {
    assignment(
      assignmentId: $assignmentId
      isImpersonating: $isImpersonating
      masterSubjectId: $subjectId
    ) {
      id
      title
      sectionId
      hasImmediateFeedback
      immediateFeedbackAttempts
      assessment {
        id: itemId
        learnosityItemReference
        title
      }
      isHardTimer
      allowLateSubmission
      questions(isImpersonating: $isImpersonating) {
        ... on MultipleChoiceQuestion {
          itemId
          title
          isSecure
          isRetired
          learnosityItemReference
          tags {
            id
            label
            description
            categories {
              id
              label
            }
          }
          type: __typename
        }
        ... on FreeResponseQuestion {
          itemId
          title
          isSecure
          isRetired
          learnosityItemReference
          tags {
            id
            label
            description
            categories {
              id
              label
            }
          }
          type: __typename
          children: scoringRubric {
            id
            title
            learnosityItemReference
            type: __typename
          }
        }
      }
      dueAt
      timezone
    }
    assignmentPlayer(
      assignmentId: $assignmentId
      subjectId: $subjectId
      config: $config
      ldbChallenge: $ldbChallenge
      isImpersonating: $isImpersonating
      impersonatingDetails: $impersonatingDetails
    ) {
      learnositySignedRequest
      allowCalculatorForItems {
        itemId
        revisionId
        learnosityItemReference
      }
      timer
      isSecure
      isCbPracticeQuiz
      ldbLink
      isSpp
      isSandbox
      sppVideos {
        questionPartReference
        displayName
        resourceId
        videoId
        unitId
        providerVideoId
      }
      timedSession {
        timeElapsed
        totalTime
        submissionStatus
        isTimerPaused
        isTimerHidden
      }
    }
  }
`;

export const worldLanguagePilotPlayerData = gql`
  query worldLanguagePilotPlayer(
    $isImpersonating: Boolean!
    $isWorldLanguageApReader: Boolean!
    $activityId: String!
    $subjectId: String!
    $studentId: String
  ) {
    worldLanguagePilotPlayer(
      isImpersonating: $isImpersonating
      isWorldLanguageApReader: $isWorldLanguageApReader
      activityId: $activityId
      subjectId: $subjectId
      studentId: $studentId
    ) {
      learnositySignedRequest
    }
  }
`;

export const assignmentReview = gql`
  query assignmentReview(
    $assignmentId: String!
    $studentId: String!
    $config: String
    $inline: Boolean
    $showCorrectAnswers: Boolean
    $assignmentIdAsInt: Int
    $subjectId: Int
    $htmlId: String
    $scorerType: String
  ) {
    assignmentReview(
      assignmentId: $assignmentId
      studentId: $studentId
      config: $config
      inline: $inline
      showCorrectAnswers: $showCorrectAnswers
      subjectId: $subjectId
      scorerType: "teacher"
    ) {
      learnositySignedRequest
      allowCalculatorForItems {
        itemId
        revisionId
        learnosityItemReference
      }
      scoringRubric {
        learnositySignedRequest
        rubricCategoryReferencesByQuestion
      }
      sppVideos {
        questionPartReference
        displayName
        resourceId
        videoId
        unitId
        providerVideoId
      }
      status
      scoreDisplay
    }
    assignment(assignmentId: $assignmentId) {
      id
      studentScoring
      studentResponses(studentId: $studentId)
      students {
        id: initId
        firstName
        lastName
      }
      scoringRubricResponseAnalysis(
        studentId: $studentId
        scorerType: $scorerType
      )
      scoringRubricResponses(studentId: $studentId, scorerType: $scorerType)
      progress(userId: $studentId) {
        scored
        studentScored
        teacherAndStudentScored
      }
      assessment {
        id: itemId
        learnosityItemReference
        title
      }
    }
    assessmentGroupByAssignmentInfo(
      assignmentId: $assignmentIdAsInt
      subjectId: $subjectId
      htmlId: $htmlId
    ) {
      type
    }
  }
`;

export const startAssignmentMutation = gql`
  mutation startAssignment($assignmentId: Int!, $isImpersonating: Boolean!) {
    startAssignment(
      assignmentId: $assignmentId
      isImpersonating: $isImpersonating
    ) {
      ok
    }
  }
`;

export const assignmentSubmitMutation = gql`
  mutation assignmentSubmit($assignmentId: String!) {
    submitAssignment(assignmentId: $assignmentId) {
      ok
    }
  }
`;

export const assignmentScoringByRubric = gql`
  query assignmentScoringByRubric(
    $studentId: String!
    $assignmentId: String
    $subjectId: Int
    $htmlId: String
    $assignmentIdAsInt: Int
    $scorerType: String!
    $isImpersonating: Boolean!
  ) {
    assignmentScoringByRubric(
      studentId: $studentId
      assignmentId: $assignmentId
      isImpersonating: $isImpersonating
    ) {
      studentSessionReviewSignedRequest
      scoringRubricSignedRequest
      rubricCategoryReferencesByQuestion
    }
    assessmentGroupByAssignmentInfo(
      assignmentId: $assignmentIdAsInt
      subjectId: $subjectId
      htmlId: $htmlId
    ) {
      id
      name
      type
      subject
    }
    assignment(assignmentId: $assignmentId) {
      id
      title
      studentScoring
      hasStudentScores
      responseAnalysis(studentId: $studentId)
      scoringRubricResponseAnalysis(
        studentId: $studentId
        scorerType: $scorerType
      )
      scoringRubricResponses(studentId: $studentId, scorerType: $scorerType)
      feedback(studentId: $studentId) {
        content
      }
      students {
        id: initId
        firstName
        lastName
      }
      printToggle
      questions {
        ... on MultipleChoiceQuestion {
          id: itemId
          title
          learnosityItemReference
          isSecure
          type: __typename
        }
        ... on FreeResponseQuestion {
          id: itemId
          title
          learnosityItemReference
          isSecure
          type: __typename
          children: scoringRubric {
            id
            title
            learnosityItemReference
            type: __typename
          }
        }
      }
      progress(userId: $studentId) {
        scored
        studentScored
        teacherAndStudentScored
      }
    }
  }
`;

export const updateScoresMutation = gql`
  mutation updateScores(
    $assignmentId: String!
    $studentId: String!
    $scores: String!
    $scoringCompleted: Boolean
  ) {
    updateScores(
      assignmentId: $assignmentId
      studentId: $studentId
      scores: $scores
      scoringCompleted: $scoringCompleted
    ) {
      ok
    }
  }
`;

export const assignmentWithScoring = gql`
  query getAssignmentWithScoring(
    $assignmentId: String
    $educationPeriod: String
  ) {
    assignment(assignmentId: $assignmentId, educationPeriod: $educationPeriod) {
      id
      progress {
        complete
        not_started: notStarted
        started
        submitted
        scoring
        mcq_scoring: mcqScoring
        scored
        student_scored: studentScored
        ready_to_score: readyToScore
        teacher_and_student_scored: teacherAndStudentScored
      }
      studentSessions {
        userId
        submittedAt
        progress {
          complete
          not_started: notStarted
          started
          submitted
          scoring
          mcq_scoring: mcqScoring
          scored
          student_scored: studentScored
          ready_to_score: readyToScore
          teacher_and_student_scored: teacherAndStudentScored
        }
      }
      resultsByItem
      learnosityScoringActivityId
      learnosityStudentScoringActivityId
      teacherScoringRubricResults: scoringRubricResults(scorerType: "teacher")
      studentScoringRubricResults: scoringRubricResults(scorerType: "student")
    }
  }
`;

export const assignmentScrambledOrder = gql`
  query getSignedAssignmentResultRequest(
    $assignmentId: String
    $educationPeriod: String
    $scrambledStudentId: String
  ) {
    assignment(assignmentId: $assignmentId, educationPeriod: $educationPeriod) {
      id
      questions(studentId: $scrambledStudentId) {
        ... on MultipleChoiceQuestion {
          id: itemId
        }
        ... on FreeResponseQuestion {
          id: itemId
        }
      }
    }
  }
`;

export const assignmentWithAssessment = gql`
  query getSignedAssignmentResultRequest(
    $assignmentId: String
    $studentId: String
    $includePriorStudents: String
    $educationPeriod: String
    $masterSubjectId: String
    $scrambledStudentId: String
  ) {
    quizIsPpc(assignmentId: $assignmentId, educationPeriod: $educationPeriod)
    assignment(assignmentId: $assignmentId, educationPeriod: $educationPeriod) {
      id
      status
      scoreDisplay
      hasImmediateFeedback
      studentResponses(studentId: $studentId)
      scoringRubricResponses(studentId: $studentId, scorerType: "teacher")
      results(
        studentId: $studentId
        includePriorStudents: $includePriorStudents
      )
      resultsByItem(
        studentId: $studentId
        includePriorStudents: $includePriorStudents
      )
      scoringRubricResults(
        studentId: $studentId
        includePriorStudents: $includePriorStudents
      )
      responseAnalysis(studentId: $studentId)
      scoringRubricResponseAnalysis(studentId: $studentId)
      studentScoringRubricResults: scoringRubricResults(
        studentId: $studentId
        scorerType: "student"
      )
      teacherScoringRubricResults: scoringRubricResults(scorerType: "teacher")
      title
      startsAt
      dueAt
      timer
      sectionName
      sectionId
      isSecure
      studentScoring
      hasStudentScores
      isIndividualAssignment
      studentScoring
      printToggle
      students {
        id: initId
        firstName
        lastName
        apuid
        email
      }
      progress(userId: $studentId) {
        submitted
        scoring
        scored
        studentScored
        teacherAndStudentScored
      }
      studentSessions {
        userId
        submittedAt
        scoringCompletedAt
      }
      feedback(studentId: $studentId) {
        content
        studentId
      }
      timeTaken(studentId: $studentId) {
        studentId
        seconds
      }
      timezone
      assessment {
        id: itemId
        title
        libraryType
        isPracticeExam
        isLearningCheckpoint
        isPerformanceTask
        associatedResources {
          resourceUrl
          resourceType
        }
        isCbPracticeQuiz
        isSampleQuiz
        isSpp
        isPpc
        is_learning_checkpoint: isLearningCheckpoint
      }
      customAssignmentSettings {
        startsAt
        dueAt
        timer
        userId
      }
      questions(studentId: $scrambledStudentId) {
        ... on MultipleChoiceQuestion {
          id: itemId
          ownerId
          title
          isSecure
          isTopicQuestion
          isRetired
          isTeacherAuthored
          learnosityItemReference
          itemShareChain
          relatedSkills(educationPeriod: $educationPeriod) {
            tagCategoryId
            title
            children {
              tagId
              label
              title
              description
              category
            }
          }
          relatedOtherTags(
            educationPeriod: $educationPeriod
            masterSubjectId: $masterSubjectId
          ) {
            id
            label
            title
            description
            category
          }
          type: __typename
        }
        ... on FreeResponseQuestion {
          id: itemId
          ownerId
          title
          isSecure
          isTopicQuestion
          isRetired
          isTeacherAuthored
          learnosityItemReference
          itemShareChain
          relatedSkills(educationPeriod: $educationPeriod) {
            tagCategoryId
            title
            children {
              tagId
              label
              title
              description
            }
          }
          relatedOtherTags(
            educationPeriod: $educationPeriod
            masterSubjectId: $masterSubjectId
          ) {
            id
            label
            title
            description
            category
          }
          children: scoringRubric {
            id
            title
            learnosityItemReference
            type: __typename
          }
          type: __typename
        }
      }
      categories(masterSubjectId: $masterSubjectId)
      scrambleQuestionsPerStudent
      scoreDisplay
    }
  }
`;

export const scoringGridAssignment = gql`
  query scoringGridAssignment($assignmentId: String) {
    assignment(assignmentId: $assignmentId) {
      id
      sessionTemplate
      scoringSessionTemplate
      responseAnalysis
      studentResponses
      scoringRubricResponseAnalysis
      scoringRubricResponses(studentId: "", scorerType: "teacher")
      teacherScoringRubricResults: scoringRubricResults(scorerType: "teacher")
      studentScoringRubricResults: scoringRubricResults(scorerType: "student")
      students {
        id: initId
        firstName
        lastName
      }
      questions {
        ... on MultipleChoiceQuestion {
          id: itemId
          title
          learnosityItemReference
          type: __typename
        }
        ... on FreeResponseQuestion {
          id: itemId
          title
          learnosityItemReference
          type: __typename
          children: scoringRubric {
            id
            title
            learnosityItemReference
            type: __typename
          }
        }
      }
    }
  }
`;

export const assignmentSessionTemplate = gql`
  query getSignedAssignmentResultRequest($assignmentId: String!) {
    assignment(assignmentId: $assignmentId) {
      id
      sessionTemplate
    }
  }
`;

export const teacherAssignments = gql`
  query getTeacherAssignments($subjectIds: [String]!) {
    teacherAssignments(subjectIds: $subjectIds) {
      assignments {
        id
        title
        sectionId
        sectionName
        sectionImportId
        isSecure
        scrambleQuestions
        students {
          id: initId
          firstName
          lastName
        }
        studentSessions {
          userId
          startedAt
          submittedAt
          scoringStartedAt
          scoringCompletedAt
          learnositySubmittedAt
        }
        status
        startsAt
        dueAt
        opened
        teacherAssigned
        assessment {
          id: itemId
          units
          libraryType
          itemId
          questions {
            ... on MultipleChoiceQuestion {
              id: itemId
              type: __typename
            }
            ... on FreeResponseQuestion {
              id: itemId
              type: __typename
            }
          }
          isPracticeExam
          isCbPracticeQuiz
          isSPP: isSpp
          isPPC: isPpc
          is_learning_checkpoint: isLearningCheckpoint
          is_performance_task: isPerformanceTask
        }
        progress {
          complete
          notStarted
          started
          submitted
          scoring
          mcqScoring
          scored
          studentScored
          readyToScore
          teacherAndStudentScored
        }
        window {
          startDate
        }
        results
        isIndividualAssignment
      }
    }
  }
`;

export const assignmentProgressWithTagPairs = gql`
  query getAssignmentProgressWithTagPairs(
    $assignmentId: String!
    $studentId: String
    $tags: String!
    $includePriorStudents: String
    $educationPeriod: String
  ) {
    assignmentProgressWithTagPairs(
      assignmentId: $assignmentId
      studentId: $studentId
      tags: $tags
      includePriorStudents: $includePriorStudents
      educationPeriod: $educationPeriod
    ) {
      attemptNumber
      resultByTags
      otherPartsResults
      otherPartsResultsByItem
      otherPartsResponseByAnalysis
      otherPartsScoringRubricResults(studentId: $studentId)
      otherPartsScoringRubricResponseAnalysis(studentId: $studentId)
      assessmentShortName
      learnosityActivityId
      tagPairs
      tagPairAbbreviations
      otherParts {
        numberOfSubmissions
        numberOfCompletedScores
        hasBeenOpened
        assessmentId
        assignmentId
        unitId
        shortName
        status
        tagPairAbbreviations
        learnosityActivityId
        learnosityScoringActivityId
        displayScore
        timer
        timeTaken(studentId: $studentId) {
          studentId
          seconds
        }
        itemData {
          itemId
          title
          canScrambleQuestions
          isSecure
        }
        studentSessions {
          userId
          submittedAt
          scoringCompletedAt
        }
        feedback(studentId: $studentId) {
          content
          studentId
        }
        questions {
          ... on MultipleChoiceQuestion {
            id: itemId
            title
            learnosityItemReference
            relatedSkills(educationPeriod: $educationPeriod) {
              tagCategoryId
              title
              children {
                tagId
                label
                title
                description
              }
            }
            type: __typename
          }
          ... on FreeResponseQuestion {
            id: itemId
            title
            learnosityItemReference
            relatedSkills(educationPeriod: $educationPeriod) {
              tagCategoryId
              title
              children {
                tagId
                label
                title
                description
              }
            }
            children: scoringRubric {
              id
              title
              learnosityItemReference
              type: __typename
            }
            type: __typename
          }
        }
      }
    }
  }
`;

export const relatedQuestions = gql`
  query relatedQuestions($assignmentId: String!, $questionId: String!) {
    relatedQuestions(assignmentId: $assignmentId, questionId: $questionId) {
      questions {
        questionId
        index
      }
    }
  }
`;

export const getEditQuestion = gql`
  query editQuestionQuery(
    $subjectId: Int!
    $itemId: Int
    $copyQuestion: Boolean
  ) {
    editQuestion(
      subjectId: $subjectId
      itemId: $itemId
      copyQuestion: $copyQuestion
    ) {
      learnositySignedRequest
      isOwner
      question {
        ... on MultipleChoiceQuestion {
          title
          tags {
            id
            categories {
              id
            }
          }
        }
        ... on FreeResponseQuestion {
          title
          tags {
            id
            categories {
              id
            }
          }
          scoringRubric {
            id
            title
            learnosityItemReference
          }
        }
      }
    }
  }
`;

export const saveQuestionMutation = gql`
  mutation saveQuestion(
    $subjectId: String!
    $type: String
    $title: String!
    $learnosityItemReference: String!
    $itemId: String
    $tags: [Int]
    $categoryItems: String
    $categoryQuestions: String
    $replaceQuestion: String
  ) {
    saveQuestion(
      subjectId: $subjectId
      type: $type
      title: $title
      learnosityItemReference: $learnosityItemReference
      itemId: $itemId
      tags: $tags
      categoryItems: $categoryItems
      categoryQuestions: $categoryQuestions
      replaceQuestion: $replaceQuestion
    ) {
      item_id: itemId
      title
      rev_id: revId
      learnosity_item_reference: learnosityItemReference
      owner_id: ownerId
      is_full_form: isFullForm
      can_scramble_questions: canScrambleQuestions
      is_secure: isSecure
      type
      is_final_exam: isFinalExam
      is_practice_exam: isPracticeExam
      is_cb_practice_quiz: isCbPracticeQuiz
      is_sample_quiz: isSampleQuiz
      used_before: usedBefore
      can_edit: canEdit
      metadata {
        title
        tag_category_id: tagCategoryId
        label
        tags {
          id
          label
          title
          description
        }
      }
    }
  }
`;

export const getQuestionsPreview = gql`
  query getQuestionsPreview(
    $questionId: Int
    $questionIds: [Int]!
    $subjectId: Int
    $config: String
    $educationPeriod: String
    $showCorrectAnswers: Boolean
  ) {
    questionsPreview(
      questionId: $questionId
      questionIds: $questionIds
      subjectId: $subjectId
      config: $config
      showCorrectAnswers: $showCorrectAnswers
    ) {
      learnositySignedRequest
      allowCalculatorForItems {
        itemId
        revisionId
        learnosityItemReference
      }
      questions {
        ... on MultipleChoiceQuestion {
          id: itemId
          title
          learnosityItemReference
          isSecure
          isRetired
          isCbPracticeQuiz
          isTopicQuestion
          type: __typename
          used_detail: usedDetail(educationPeriod: $educationPeriod)
          owner_id: ownerId
          isTeacherAuthored: isTeacherAuthored
          item_share_chain: itemShareChain
        }
        ... on FreeResponseQuestion {
          id: itemId
          title
          isSecure
          isRetired
          learnosityItemReference
          isCbPracticeQuiz
          isTopicQuestion
          type: __typename
          children: scoringRubric {
            id
            title
            learnosityItemReference
            type: __typename
          }
          used_detail: usedDetail(educationPeriod: $educationPeriod)
          owner_id: ownerId
          isTeacherAuthored: isTeacherAuthored
          item_share_chain: itemShareChain
        }
      }
    }
  }
`;

export const getSampleExam = gql`
  query getSampleExam($subjectId: Int!, $config: String) {
    sampleExam(subjectId: $subjectId, config: $config) {
      learnositySignedRequest
      allowCalculatorForItems {
        itemId
        revisionId
        learnosityItemReference
      }
      questions {
        ... on MultipleChoiceQuestion {
          id: itemId
          title
          learnosityItemReference
          type: __typename
        }
        ... on FreeResponseQuestion {
          id: itemId
          title
          learnosityItemReference
          type: __typename
          children: scoringRubric {
            id
            title
            learnosityItemReference
            type: __typename
          }
        }
      }
    }
  }
`;

export const getQuestionsTypesOnAssignment = gql`
  query getQuestionsTypesOnAssignment(
    $assignmentId: String
    $educationPeriod: String
  ) {
    assignment(assignmentId: $assignmentId, educationPeriod: $educationPeriod) {
      id
      title
      timezone
      reviewUntil
      isReviewDisabled
      startsAt
      dueAt
      window {
        startDate
        endDate
      }
      assignmentPaperscorerAnswerSheet
      questions {
        ... on MultipleChoiceQuestion {
          id: itemId
          itemId
          title
          isSecure
          isRetired
          learnosityItemReference
          isCbPracticeQuiz
          isTopicQuestion
          isTeacherAuthored
          type: __typename
        }
        ... on FreeResponseQuestion {
          id: itemId
          itemId
          title
          isSecure
          isRetired
          isTopicQuestion
          learnosityItemReference
          isCbPracticeQuiz
          isTeacherAuthored
          type: __typename
          children: scoringRubric {
            id
            title
            learnosityItemReference
            type: __typename
          }
        }
      }
    }
  }
`;

// Annotations
export const annotationDataQuery = gql`
  query getLearnosityAssignmentAnnotations($assignmentId: Int!) {
    learnosityAssignmentAnnotations(assignmentId: $assignmentId) {
      id
      annotation
      highlight {
        id
        item
        path
        offset
        selection
        color
      }
    }
  }
`;

export const createAnnotationMutation = gql`
  mutation createLearnosityAnnotation(
    $assignmentId: Int!
    $annotation: String!
    $highlight: HighlightInput!
  ) {
    createLearnosityAnnotation(
      assignmentId: $assignmentId
      annotation: $annotation
      highlight: $highlight
    ) {
      ok
    }
  }
`;

export const updateAnnotationMutation = gql`
  mutation updateLearnosityAnnotation(
    $learnosityAnnotationId: Int!
    $annotation: String!
  ) {
    updateLearnosityAnnotation(
      annotationId: $learnosityAnnotationId
      annotation: $annotation
    ) {
      ok
    }
  }
`;

export const deleteAnnotationMutation = gql`
  mutation deleteLearnosityAnnotation($learnosityAnnotationId: Int!) {
    deleteLearnosityAnnotation(annotationId: $learnosityAnnotationId) {
      ok
    }
  }
`;

export const assessmentTestPreviewQuery = gql`
  query getAssessmentTestPreview(
    $assessmentId: String!
    $masterSubjectId: String!
  ) {
    assessment(assessmentId: $assessmentId) {
      id: itemId
      previewPdfUrl(masterSubjectId: $masterSubjectId)
    }
  }
`;

export const assignmentScoringGuideQuery = gql`
  query getAssignmentScoringGuide(
    $assignmentId: String!
    $masterSubjectId: String!
  ) {
    assignment(assignmentId: $assignmentId) {
      id
      scoringGuideUrl(masterSubjectId: $masterSubjectId)
    }
  }
`;

export const assessmentScoringGuideQuery = gql`
  query getAssessmentScoringGuide(
    $assessmentId: String!
    $masterSubjectId: String!
  ) {
    assessment(assessmentId: $assessmentId) {
      id: itemId
      scoringGuideUrl(masterSubjectId: $masterSubjectId)
    }
  }
`;

export const assessmentTestBookletQuery = gql`
  query getAssessmentTestBookletQuery(
    $assessmentId: String!
    $masterSubjectId: String!
  ) {
    assessment(assessmentId: $assessmentId) {
      id
      testBookletUrl(masterSubjectId: $masterSubjectId)
    }
  }
`;

export const logSubjectVisitMutation = gql`
  mutation logSubjectVisit($path: String!) {
    logSubjectVisit(path: $path) {
      logged
    }
  }
`;

export const trackResultsVisit = gql`
  mutation trackResultsVisit($assignmentId: String!) {
    trackResultsVisit(assignmentId: $assignmentId) {
      tracked
    }
  }
`;

export const trackItemResultsVisit = gql`
  mutation trackItemResultsVisit($assignmentId: String!, $itemId: String!) {
    trackItemResultsVisit(assignmentId: $assignmentId, itemId: $itemId) {
      tracked
    }
  }
`;

export const proctoringQuery = gql`
  query getAssignmentProctoring($assignmentId: String!, $htmlId: String!) {
    assignmentProctoring(assignmentId: $assignmentId, htmlId: $htmlId) {
      learnositySignedRequest
    }
  }
`;

export const extendTimeMutation = gql`
  mutation extendTimeMutation(
    $assignmentId: Int!
    $studentIds: [Int!]
    $minutes: Int!
  ) {
    extendSessionTime(
      assignmentId: $assignmentId
      studentIds: $studentIds
      minutes: $minutes
    ) {
      ok
    }
  }
`;

export const assignmentSession = gql`
  query getassignmentSession($assignmentId: Int!, $isImpersonating: Boolean!) {
    assignmentSession(
      assignmentId: $assignmentId
      isImpersonating: $isImpersonating
    ) {
      id: assignmentId
      timedSession {
        timeElapsed
        totalTime
        submissionStatus
      }
    }
  }
`;

export const getQuestionRubrics = gql`
  query getQuestionRubrics($questionId: String!, $program: String!) {
    questionRubricPreview(questionId: $questionId, program: $program) {
      learnositySignedRequest
    }
  }
`;

export const getStimulusQuestions = gql`
  query getStimulusQuestions($stimulusId: String!, $subjectId: String!) {
    stimulusQuestions(stimulusId: $stimulusId, subjectId: $subjectId) {
      questions {
        item_id: itemId
        rev_id: revId
        title: title
        is_full_form: isFullForm
        owner_id: ownerId
        can_scramble_questions: canScrambleQuestions
        is_sample_quiz: isSampleQuiz
        metadata {
          tag_category_id: tagCategoryId
          label
          title
          tags {
            id
            label
            title
            description
          }
        }
        learnosity_item_reference: learnosityItemReference
        is_secure: isSecure
        type: type
        can_edit: canEdit
        used_before: usedBefore
        used_detail: usedDetail
      }
    }
  }
`;

export const getQuizQuestionInfo = gql`
  query quizHasNonSecureQns(
    $assessmentId: String!
    $assignmentId: String
    $questionTypes: String
  ) {
    quizHasNonSecureQns(
      assessmentId: $assessmentId
      assignmentId: $assignmentId
      questionTypes: $questionTypes
    )
  }
`;

export const questions = gql`
  query questions(
    $subjectId: Int!
    $orderBy: String
    $page: Int
    $filterTagIds: String
    $excludeHigherTagCategoryIds: String
    $includeOnlyTagCategoryIds: String
    $searchTerm: String
    $searchFor: String
    $educationPeriod: String
    $sortTagsBy: String
    $statusFilter: String
  ) {
    questions(
      subjectId: $subjectId
      orderBy: $orderBy
      page: $page
      filterTagIds: $filterTagIds
      excludeHigherTagCategoryIds: $excludeHigherTagCategoryIds
      includeOnlyTagCategoryIds: $includeOnlyTagCategoryIds
      searchTerm: $searchTerm
      searchFor: $searchFor
      educationPeriod: $educationPeriod
      sortTagsBy: $sortTagsBy
      statusFilter: $statusFilter
    ) {
      currentPage
      columnLabels
      itemsColumns
      items
      hasMore
      perPage
      total
      addAllItemIds
      type: __typename
    }
  }
`;

export const getAssessmentSecurityInfo = gql`
  query getAssessmentSecurityInfo($assessmentId: String!) {
    assessment(assessmentId: $assessmentId) {
      id: itemId
      isSecure
      isPracticeExam
      learnosityItemReference
      questions {
        ... on MultipleChoiceQuestion {
          isSecure
          type: __typename
        }
        ... on FreeResponseQuestion {
          isSecure
          type: __typename
        }
      }
    }
  }
`;

export const getAssessmentInfo = gql`
  query getAssessmentInfo($assessmentId: String!, $educationPeriod: String!) {
    assessment(assessmentId: $assessmentId, educationPeriod: $educationPeriod) {
      id: itemId
      item_id: itemId
      title
      libraryType
      isSecure
      isPracticeExam
      isCbPracticeQuiz
      is_spp: isSpp
      is_ppc: isPpc
      is_learning_checkpoint: isLearningCheckpoint
      canScrambleQuestions
      isSampleQuiz
      isOwner
      isInCoTaughtClass
      isAssigned
      isInProgress
      associatedResources {
        resourceUrl
        resourceType
      }
    }
  }
`;

export const getQBCreateAddInfo = gql`
  query getQBCreateAddInfo(
    $itemIds: [Int]!
    $subjectId: String!
    $educationPeriod: String!
  ) {
    qbCreateAdd(
      itemIds: $itemIds
      subjectId: $subjectId
      educationPeriod: $educationPeriod
    ) {
      isPracticeExam
      isOwner
      itemToStimulusMap {
        question_id: questionId
        stimulus {
          id
          rev_id: revId
          title
          created
          updated
          type
          learnosity_item_reference: learnosityItemReference
          is_secure: isSecure
        }
      }
      questions {
        id
        rev_id: revId
        title
        created
        updated
        type
        learnosity_item_reference: learnosityItemReference
        is_secure: isSecure
        is_retired: isRetired
        is_cb_practice_quiz: isCbPracticeQuiz
        owner_id: ownerId
        is_topic_question: isTopicQuestion
        calculator_section: calculatorSection
        metadata {
          tag_category_id: tagCategoryId
          label
          title
          tags {
            id
            label
            title
            description
          }
        }
        used_before: usedBefore
        used_detail: usedDetail
      }
      stimuli {
        stimulus_id: stimulusId
        questions {
          item_id: itemId
          rev_id: revId
          title: title
          is_full_form: isFullForm
          owner_id: ownerId
          is_cb_practice_quiz: isCbPracticeQuiz
          is_topic_question: isTopicQuestion
          can_scramble_questions: canScrambleQuestions
          metadata {
            tag_category_id: tagCategoryId
            label
            title
            tags {
              id
              label
              title
              description
            }
          }
          learnosity_item_reference: learnosityItemReference
          is_secure: isSecure
          type: type
          can_edit: canEdit
          used_before: usedBefore
          used_detail: usedDetail
        }
      }
    }
  }
`;

export const getQBCreateAssessmentInfo = gql`
  query getQBCreateAssessmentInfo(
    $assessmentId: String!
    $subjectId: String!
    $educationPeriod: String!
    $isQuestionsDataUsed: Boolean
  ) {
    qbCreateEdit(
      assessmentId: $assessmentId
      subjectId: $subjectId
      educationPeriod: $educationPeriod
      isQuestionsDataUsed: $isQuestionsDataUsed
    ) {
      id
      title
      isPracticeExam
      isOwner
      labels {
        labelId
      }
      itemToStimulusMap {
        question_id: questionId
        stimulus {
          id
          rev_id: revId
          title
          created
          updated
          type
          learnosity_item_reference: learnosityItemReference
          is_secure: isSecure
        }
      }
      questions {
        id
        rev_id: revId
        title
        created
        updated
        type
        learnosity_item_reference: learnosityItemReference
        is_secure: isSecure
        is_retired: isRetired
        is_cb_practice_quiz: isCbPracticeQuiz
        owner_id: ownerId
        is_topic_question: isTopicQuestion
        calculator_section: calculatorSection
        metadata {
          tag_category_id: tagCategoryId
          label
          title
          tags {
            id
            label
            title
            description
          }
        }
        used_before: usedBefore
        used_detail: usedDetail
        item_share_chain: itemShareChain
      }
      stimuli {
        stimulus_id: stimulusId
        questions {
          item_id: itemId
          rev_id: revId
          title: title
          is_full_form: isFullForm
          owner_id: ownerId
          is_cb_practice_quiz: isCbPracticeQuiz
          is_topic_question: isTopicQuestion
          can_scramble_questions: canScrambleQuestions
          metadata {
            tag_category_id: tagCategoryId
            label
            title
            tags {
              id
              label
              title
              description
            }
          }
          learnosity_item_reference: learnosityItemReference
          is_secure: isSecure
          type: type
          can_edit: canEdit
          used_before: usedBefore
          used_detail: usedDetail
          item_share_chain: itemShareChain
        }
      }
    }
  }
`;

export const deleteAssessmentMutation = gql`
  mutation deleteAssesment($itemId: Int!, $shouldConfirmDelete: Boolean) {
    deleteAssessment(
      itemId: $itemId
      shouldConfirmDelete: $shouldConfirmDelete
    ) {
      deleted
      message
      canBeDeleted
    }
  }
`;

export const submitSessions = gql`
  mutation submitSessions($assignmentId: String!, $userIds: [Int]!) {
    submitSessions(assignmentId: $assignmentId, userIds: $userIds) {
      ok
    }
  }
`;

export const unsubmitSessions = gql`
  mutation unsubmitSessions($assignmentId: String!, $userIds: [Int]!) {
    unsubmitSessions(assignmentId: $assignmentId, userIds: $userIds) {
      ok
    }
  }
`;

export const createQuiz = gql`
  mutation createQuiz(
    $libraryId: Int!
    $title: String!
    $content: JSONString!
  ) {
    createQuiz(libraryId: $libraryId, title: $title, content: $content) {
      ok
      itemId
    }
  }
`;

export const updateQuiz = gql`
  mutation updateQuiz($itemId: Int!, $title: String!, $content: JSONString!) {
    updateQuiz(itemId: $itemId, title: $title, content: $content) {
      ok
    }
  }
`;

export const copyAssessment = gql`
  mutation copyAssessment($assessmentId: Int!, $subjectId: Int!) {
    copyAssessment(assessmentId: $assessmentId, subjectId: $subjectId) {
      ok
      newAssessment {
        itemId
      }
      message
    }
  }
`;

export const getAggregatedVideoStats = gql`
  query getAggregatedVideoStats(
    $videoIds: [Int!]
    $subjectId: Int!
    $resourceIds: [String!]
    $userIds: [Int]
  ) {
    aggregatedVideoStatus(
      videoIds: $videoIds
      subjectId: $subjectId
      resourceIds: $resourceIds
      userIds: $userIds
    ) {
      totalStudents
      watchedStudents
      stats {
        school
        classProgress {
          className
          classId
          assigned
          studentProgress {
            firstName
            lastName
            completed
          }
        }
      }
    }
  }
`;

export const getAdminCoordAggregatedVideoStats = gql`
  query getAggregatedAdminVideoStats(
    $videoIds: [Int!]
    $subjectId: Int!
    $resourceIds: [String!]
    $userIds: [Int]
  ) {
    aggregatedVideoStatus(
      videoIds: $videoIds
      subjectId: $subjectId
      resourceIds: $resourceIds
      userIds: $userIds
    ) {
      totalStudents
      watchedStudents
      stats {
        school
        classProgress {
          className
          classId
          assigned
          totalStudents
          watchedStudents
        }
      }
    }
  }
`;

export const getSharedResources = gql`
  query getSharedResources(
    $subjectId: Int!
    $classIds: [String]!
    $educationPeriod: Int!
  ) {
    sharedVideoResources(
      subjectId: $subjectId
      classIds: $classIds
      educationPeriod: $educationPeriod
    ) {
      id
      isVideo
      displayName
      date
      headline
      description
      link
      message
      status
      icon {
        name
        height
        width
        clickable
      }
    }
  }
`;

export const userVideoResourceStatusListQuery = gql`
  query userVideoResourceStatusList(
    $videoIds: [Int]
    $userIds: [Int]
    $subjectId: Int!
  ) {
    userVideoResourceStatusList(
      videoIds: $videoIds
      userIds: $userIds
      subjectId: $subjectId
    )
  }
`;

export const getVideoPlayTimePercentages = gql`
  query getVideoPlayTimePercentages(
    $providerVideoIds: [String!]
    $subjectId: Int!
  ) {
    getVideoPlayTimePercentages(
      providerVideoIds: $providerVideoIds
      subjectId: $subjectId
    )
  }
`;

export const getSearchedResources = gql`
  query filteredResources(
    $resourceTypes: [String]!
    $subjectId: Int!
    $searchTerm: String
    $educationPeriod: Int!
    $sortOrder: String
    $resourceSubType: String
  ) {
    filteredResources(
      resourceTypes: $resourceTypes
      subjectId: $subjectId
      searchTerm: $searchTerm
      educationPeriod: $educationPeriod
      sortOrder: $sortOrder
      resourceSubType: $resourceSubType
    ) {
      resource {
        id
        displayName
        description
        icon
        group
        ... on EmbeddedVideoResource {
          isShareable
          fileSize
          url
          videoId
          thumbnailUrl
        }
        ... on AssessmentResource {
          assessmentId
          resourceTypeDetails
        }
        ... on StudentPracticeResource {
          assessmentId
        }
        ... on URLResource {
          isShareable
          fileSize
          url
          contentType
        }
        ... on SourceResource {
          isShareable
          fileSize
          url
          contentType
        }
        ... on LTIResource {
          isShareable
          url
        }
      }
      unit
      subunit
      displayTags
      resourceCount
      ppcStudentLearnositySignedRequest
    }
  }
`;

export const itemRelatedVideos = gql`
  query itemRelatedVideos(
    $itemId: Int!
    $educationPeriod: Int
    $masterSubjectId: Int!
  ) {
    relatedVideos(
      itemId: $itemId
      educationPeriod: $educationPeriod
      masterSubjectId: $masterSubjectId
    ) {
      videos {
        id
        displayName
        url
        videoId
        unitId
        thumbnailUrl
        description
      }
    }
  }
`;

export const pauseSessionMutation = gql`
  mutation pauseSessionMutation($assignmentId: Int!, $studentIds: [Int!]) {
    pauseSession(assignmentId: $assignmentId, studentIds: $studentIds) {
      ok
    }
  }
`;

export const resumeSessionMutation = gql`
  mutation resumeSessionMutation($assignmentId: Int!, $studentIds: [Int!]) {
    resumeSession(assignmentId: $assignmentId, studentIds: $studentIds) {
      ok
    }
  }
`;

export const videoMarkComplete = gql`
  mutation markCompleteEmbedVideo($id: Int!) {
    markCompleteEmbedVideo(id: $id) {
      ok
    }
  }
`;

export const deleteApVideoAssignment = gql`
  mutation deleteApVideoAssignment($id: Int!) {
    deleteApVideoAssignment(id: $id) {
      ok
    }
  }
`;

export const itemShareInviteCopyLink = gql`
  mutation itemShareInviteCopyLink(
    $masterSubjectId: Int!
    $period: Int!
    $itemId: Int!
    $copyLinkButton: Boolean!
    $description: String
    $emails: [String]
  ) {
    itemShareInvite(
      masterSubjectId: $masterSubjectId
      period: $period
      itemId: $itemId
      copyLinkButton: $copyLinkButton
      description: $description
      emails: $emails
    ) {
      itemShareInvite {
        shareKey
        itemId
        copyLinkButton
        emails
        createdAt
        updatedAt
        masterSubjectId
      }
    }
  }
`;

export const checkShareInviteEmail = gql`
  query checkShareInviteEmail(
    $email: String!
    $itemId: Int!
    $educationPeriod: Int!
  ) {
    checkShareInviteEmail(
      email: $email
      itemId: $itemId
      educationPeriod: $educationPeriod
    ) {
      isValid
      email
    }
  }
`;

export const itemShares = gql`
  query getItemShares($masterSubjectId: Int!) {
    itemShares(masterSubjectId: $masterSubjectId) {
      itemMetadata {
        numberOfQuestions
        numberOfMcq
        numberOfFrq
        numberOfTeacherQuestions
      }
      assessment {
        id: itemId
        title
        is_assigned: isAssigned
        is_in_progress: isInProgress
        units
      }
      initId
      oldItemId
      itemId
      ownerId
      sharerId
      creatorId
      shareKey
      status
      lastModified
      updatedAt
      disabledAt
      sharer
      sharedAt
      isDisabled
      title
    }
  }
`;

export const getItemShareInvitesQuery = gql`
  query getItemShareInvites($masterSubjectId: Int!) {
    itemShareInvites(masterSubjectId: $masterSubjectId) {
      itemMetadata {
        numberOfQuestions
        numberOfMcq
        numberOfFrq
        numberOfTeacherQuestions
      }
      assessment {
        id: itemId
        title
        is_assigned: isAssigned
        is_in_progress: isInProgress
        units
      }
      itemInfo {
        lastModifiedDate
        isOwner
      }
      initId
      oldItemId: itemId
      itemId
      ownerId: initId
      creatorId: createdBy
      shareKey
      createdBy: createdAt
      updatedAt
      sharer: initId
      sharedAt: updatedAt
      disabledAt
      isDisabled
    }
  }
`;

export const assignmentTimer = gql`
  query getAssignmentTimer($assignmentId: String, $educationPeriod: String) {
    assignment(assignmentId: $assignmentId, educationPeriod: $educationPeriod) {
      id
      timer
    }
  }
`;

export const deleteQuestionMutation = gql`
  mutation DeleteQuestionMutation($itemId: Int!) {
    retireItem(itemId: $itemId) {
      ok
    }
  }
`;

export const getAggregatedSppStats = gql`
  query getAggregatedSppStats($subjectId: Int!, $itemId: Int!) {
    aggregatedSppStats(subjectId: $subjectId, itemId: $itemId) {
      totalStudents
      submittedStudents
      stats {
        school
        classProgress {
          className
          classId
          assigned
          totalStudents
          submittedStudents
          startedStudents
          notStartedStudents
          studentProgress {
            firstName
            lastName
            hasStarted
            hasSubmitted
          }
        }
      }
    }
  }
`;

export const GeneratePracticeQuiz = gql`
  query getGeneratePracticeQuiz(
    $masterSubjectId: Int!
    $tagCategoryId: Int!
    $tagsPerformance: [TagPerformance]!
    $allowedPracticeExams: [Int]!
    $mcqNum: Int!
    $frqNum: Int!
    $excludeInterval: Int!
  ) {
    generatePracticeQuiz(
      masterSubjectId: $masterSubjectId
      tagCategoryId: $tagCategoryId
      tagsPerformance: $tagsPerformance
      allowedPracticeExams: $allowedPracticeExams
      mcqNum: $mcqNum
      frqNum: $frqNum
      excludeInterval: $excludeInterval
    ) {
      errors
      warnings
      questions {
        ... on MultipleChoiceQuestion {
          id
          itemId
          isTeacherAuthored
          __typename
          tags {
            id
            description
            label
            __typename
            categories {
              id
              label
            }
          }
        }
        ... on FreeResponseQuestion {
          id
          itemId
          isTeacherAuthored
          __typename
          tags {
            id
            description
            label
            __typename
            categories {
              id
              label
            }
          }
        }
      }
    }
  }
`;

export const AutoGenerateQuiz = gql`
  mutation autoGenerateQuiz(
    $libraryId: Int!
    $title: String!
    $content: JSONString!
    $autoCreateContent: Boolean
    $questionIds: String
  ) {
    createQuiz(
      libraryId: $libraryId
      title: $title
      content: $content
      autoCreateContent: $autoCreateContent
      questionIds: $questionIds
    ) {
      ok
      itemId
    }
  }
`;

export const CreateDynamicAssessment = gql`
  mutation CreateDynamicQuiz(
    $masterSubjectId: Int!
    $title: String!
    $excludeInterval: Int!
    $saveReport: Boolean
    $useDefaultConfiguration: Boolean
    $allowedPracticeExams: [Int]
  ) {
    createDynamicQuiz(
      masterSubjectId: $masterSubjectId
      title: $title
      excludeInterval: $excludeInterval
      saveReport: $saveReport
      useDefaultConfiguration: $useDefaultConfiguration
      allowedPracticeExams: $allowedPracticeExams
    ) {
      quizzesDetails {
        itemId
        title
        quizType
        itemsLength
      }
      errors
      warnings
      message
    }
  }
`;

export const AssessmentAssignedInfoQuery = gql`
  query getAssessmentAssignedInfo($assessmentId: Int, $educationPeriod: Int) {
    assessmentAssignedInfo(
      assessmentId: $assessmentId
      educationPeriod: $educationPeriod
    ) {
      assignmentId
      sectionName
      groupId
      scoredDateMin
      scoredDateMax
    }
  }
`;
